import React, { useEffect, useState } from "react";
import { loadGoogleMaps } from "../utils/loadGoogleMaps";
import Sidebar from "./sidebar";
import Header from "./header";

const RoadMap = () => {
  const [trackData, setTrackData] = useState([]);

  useEffect(() => {
    const fetchTrackData = async () => {
      try {
        const response = await fetch("https://ward3-chandrapur-api.palikaapp.com/api/track/all");
        const data = await response.json();
        setTrackData(data);
      } catch (error) {
        console.error("Error fetching track data:", error);
      }
    };
    fetchTrackData();
  }, []);

  useEffect(() => {
    const initMap = async () => {
      try {
        const googleMaps = await loadGoogleMaps(
          "AIzaSyB4Z418MHwoKYfrN9wq28zZvgqtfwmNXa4"
        );

        const initialCenter =
          trackData.length > 0
            ? {
                lat: parseFloat(trackData[0].latitude),
                lng: parseFloat(trackData[0].longitude),
              }
            : { lat: 27.7, lng: 85.3 };

        const map = new googleMaps.Map(document.getElementById("map"), {
          zoom: 12,
          center: initialCenter,
          mapTypeId: "terrain",
        });

        const roadColor = "#FF0000";

        if (window.existingPolylines) {
          window.existingPolylines.forEach((polyline) =>
            polyline.setMap(null)
          );
        }

        const roads = {};
        trackData.forEach((point) => {
          const roadName = point.road;
          const roadId = point.roadId;
          if (!roads[roadId]) {
            roads[roadId] = { name: roadName, path: [] };
          }
          roads[roadId].path.push({
            lat: parseFloat(point.latitude),
            lng: parseFloat(point.longitude),
          });
        });

        window.existingPolylines = [];
        Object.keys(roads).forEach((roadId) => {
          const roadData = roads[roadId];
          const roadPath = roadData.path;
          const flightPath = new googleMaps.Polyline({
            path: roadPath.map((p) => ({ lat: p.lat, lng: p.lng })),
            geodesic: true,
            strokeColor: roadColor,
            strokeOpacity: 1.0,
            strokeWeight: 5,
          });
          flightPath.setMap(map);
          window.existingPolylines.push(flightPath);

          flightPath.addListener("mouseover", (event) => {
            const infowindow = new googleMaps.InfoWindow({
              content: `<div style="font-weight: bold; color: #000;">
                          Road: ${roadData.name}<br/>
                          ID: ${roadId}
                        </div>`,
              position: event.latLng,
            });
            infowindow.open(map);
            flightPath.addListener("mouseout", () => {
              infowindow.close();
            });
          });
        });
      } catch (error) {
        console.error("Failed to load Google Maps:", error);
      }
    };

    if (trackData.length > 0) {
      initMap();
    }
  }, [trackData]);

  return (
    <div className="flex flex-col md:flex-row bg-gray-100">
          <Header />
      <div className="flex-1 pt-20">
      <Sidebar />
      
        <div className="bg-white p-6 md:p-12 rounded-lg shadow-lg max-w-7xl mx-auto mt-10 pt-10 ml-80">
          <h1 className="text-xl md:text-2xl font-bold mb-6 text-center">
            बाटोहरुको नक्सा
          </h1>
          <div
            id="map"
            className="h-96 sm:h-[400px] md:h-[600px] w-full rounded-lg shadow-md"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default RoadMap;
